import { Button } from '@mui/material';
import { Option } from '../__generated__/graphql';
import { useEffect, useState } from 'react';
import { OptionStatusToColour, OptionStatus } from '../types/Option';
import { OptionCardStyles } from '../styles/OptionCardStyles';

interface OptionCardProps {
  option: Option;
  letter: string;
  onSelectOption: (option: Option) => void;
  status: OptionStatus;
  disabled: boolean;
}

const OptionCard = ({
  option,
  letter,
  status,
  onSelectOption,
  disabled,
}: OptionCardProps) => {
  const [optionColor, setOptionColor] = useState<string>(
    OptionStatusToColour[OptionStatus.NOT_CHOSEN],
  );

  useEffect(() => {
    setOptionColor(OptionStatusToColour[status]);
  }, [status]);

  const handleSelectOption = () => {
    setOptionColor(
      option.isAnswer
        ? OptionStatusToColour[OptionStatus.CHOSEN_CORRECT]
        : OptionStatusToColour[OptionStatus.CHOSEN_INCORRECT],
    );
    onSelectOption(option);
  };

  return (
    <Button
      sx={OptionCardStyles.button(optionColor)}
      disabled={disabled}
      onClick={handleSelectOption}
    >
      <span
        style={OptionCardStyles.letterSpan(optionColor) as React.CSSProperties}
      >
        {letter}
      </span>
      <span style={OptionCardStyles.descSpan}>{option.desc}</span>
    </Button>
  );
};

export default OptionCard;
